<template>
  <Tables
    ref="tableGrid"
    :columns="['Nome', 'Tipo de Pessoa', 'CPF/CNPJ', 'Email']"
    :showTipFooter="false"
    @Load="onLoadAssociates"
  >
    <tr v-for="obj in this.objList" v-bind:key="obj.id">
      <TableColumn :IsText="true" :status="1" :value="obj.pessoa ? obj.pessoa.nome : ''" />
      <TableColumn :IsText="true" :status="1" :value="obj.pessoa ? obj.pessoa.tipoPessoa : ''" />
      <TableColumn :IsText="true" :status="1" :value="obj.pessoa ? onFormatDocument(obj.pessoa.document) : ''" />
      <TableColumn :IsText="true" :status="1" :value="obj.pessoa ? obj.pessoa.email : ''" />
    </tr>
  </Tables>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'WithoutManagerTable',
  mixins: [ActionsForm],
  methods: {
    async onLoad () {
      await this.onLoadAssociates()
    },
    async onLoadAssociates () {
      const response = await AssociateRepository.GetAllWithoutManager(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
      this.onResultGrid(response)
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/StartPage/WithoutManagerTable.vue